<template>
    <div>
        <div class="title-container">
            <h2 class="search-title">{{ searchboxheadlineflighthelp[getCurrentLocale] }}</h2>
            <p>{{ searchboxheadlineflights2[getCurrentLocale] }}</p>
            <i class="soap-icon-message"></i>
        </div>

        <section id="content" style="padding-top: 20px; background-color: #fff;">
            <div id="main">
                <div class="contact-address block" style="margin-left: 20px; margin-right: 20px;">
                    <h4 class="skin-color">{{ hellotext1[getCurrentLocale] }}</h4>
                    <p v-html="hellotext2[getCurrentLocale]"></p>
                    <br />

                    <div class="row">
                        <div class="col-md-12">
                            <div class="icon-box style5">
                                <i class="soap-icon-phone"></i>
                                <div class="description">
                                    <small>{{ weareon[getCurrentLocale] }}</small>
                                    <h5>Tel. +49 (0) 30 - 53 676 791</h5>
                                </div>
                            </div>
                        </div>
                    </div>

                    <br />

                    <div class="row">
                        <div class="col-md-12">
                            <div class="icon-box style5">
                                <i class="soap-icon-message"></i>
                                <div class="description">
                                    <small>{{ sendusemail[getCurrentLocale] }}</small>
                                    <h5><a href="mailto:kundenservice@sundair.com">kundenservice@sundair.com</h5>
                                </div>
                            </div>
                        </div>
                    </div>

                    <br />

                    <div class="row">
                        <div class="col-md-12">
                            <div class="icon-box style5">
                                <i class="soap-icon-address"></i>
                                <div class="description">
                                    <small>{{ meetusat[getCurrentLocale] }}</small>
                                    <h5>SUNDAIR GmbH, Knieperdamm 79, 18435 Stralsund</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {

        /* >>> *************************************************************** /  /* Data */
        data: function() {

            return {
                searchboxheadlineflighthelp: {
                    en: 'Help & Contact',
                    de: 'Hilfe & Kontakt',
                },
                searchboxheadlineflights2: {
                    en: 'Discover the world with SUNDAIR!',
                    de: 'Entdecke die Welt mit SUNDAIR!',
                },
                weareon : {
                    en: 'Customer Service Department',
                    de: 'Abt. Kundenservice',
                },
                sendusemail: {
                    en: 'Send us email on',
                    de: 'Senden Sie uns eine E-Mail an',
                },
                meetusat: {
                    en: 'Meet us at',
                    de: 'Treffen Sie uns unter',
                },
                hellotext1 : {
                    en: 'Dear passenger,',
                    de: 'Sehr geehrter Fluggast,',
                },
                hellotext2 : {
                    en: 'we will be glad to help you. We are at your disposal on Mo - Fr from 09 a.m. - 6 p.m.<br />Simply get in touch with us.<br /><br /><h5>Your SUNDAIR</h5>',
                    de: 'gerne helfen wir Ihnen weiter. Wir stehen Ihnen Mo - Fr von  09 - 18 Uhr zur Verfügung.<br />Nehmen Sie doch einfach Kontakt zu uns auf.<br /><br /><h5>Ihre SUNDAIR</h5>',
                },
                // currentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .icon-box.style5 > i {
        background: #ec008b;
    }
    .icon-box.style5 {
        background: #f5f5f5;
    }

</style>


// WEBPACK FOOTER //
// src/components/shared/forms/HelpTab.vue